<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                    {{ $t('listeProduitReseauTempo.reseauLc.title') }}
                </h1>
                <breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="buttons">
              <button class="button is-addOrEdit"
                      @click="checkPermissions(permCatalogue.maj) ?
                      $router.push({name: 'm.bodac.catalogue-nouveauReseauLc',
                        params: { isFromListeProduitReseauLc : true}}) : showPopUp()"
                      :class="{
                        'button-access-no-permission' : !checkPermissions(permCatalogue.maj)
                        }">
                {{ $t('listeProduitReseauTempo.reseauLc.ajouter')}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <store-recherche-provider
        :name="storeName"
        :copy="storeProduitReseau"
        :copyChanges="changesStore">
            <liste-produit-reseau
            :typeReseau="[constantes.CATEGORIE_REGROUPEMENT_LC]"
            :referenceTable="referenceTable"
            :storeName="storeName"/>
    </store-recherche-provider>
  </div>
</template>

<script>

import breadcrumb from '@/components/general/breadcrumb';
import { createNamespacedHelpers } from 'vuex';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import { CATEGORIE_REGROUPEMENT_LC } from '@/configuration/catalogue/produitConf';
import { REFERENCE_TABLE_PRODUIT_RESEAU_LC } from '@/configuration/general/referenceTableConf';
import listeProduitReseau from '@/components/catalogue/produitReseau/listeProduitReseau';
import storeRechercheProvider from '@/components/general/store/storeRechercheProvider';
import storeProduitReseau from '@/store/modules/produitReseau';
import genererCritereRecherche
  from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitReseauTempo';
import { RESET_STATE } from '@/store/mutation-type';
import cloneDeep from 'lodash/cloneDeep';

const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      permCatalogue: CATALOGUE,
      referenceTable: REFERENCE_TABLE_PRODUIT_RESEAU_LC,
      constantes: {
        CATEGORIE_REGROUPEMENT_LC,
      },
      storeName: 'listeProduitReseauLc',
      storeProduitReseau,
    };
  },
  components: {
    breadcrumb,
    storeRechercheProvider,
    listeProduitReseau,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('listeProduitReseauTempo.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeProduitReseauTempo.reseauLc.title'), route: '', isActive: true },
      ];
    },
    changesStore() {
      const newState = {
        items: [],
        total: 0,
        criteresRecherche: genererCritereRecherche(),
        lastPayload: {},
      };
      newState.criteresRecherche.categories = [CATEGORIE_REGROUPEMENT_LC];
      return {
        state: cloneDeep(newState),
        mutations: {
          [RESET_STATE](state) {
            const s = cloneDeep(newState);
            Object.keys(state).forEach(key => {
              state[key] = s[key];
            });
          },
        },
      };
    },
  },
  methods: {
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
  },
  mounted() {
    this.setInformationPage(this.$t('pageGescom.produitReseauLc.liste'));
  },
};
</script>
